import classNames from "classnames";
import AlertCircle from "@endya-conformite/ui-kit/src/assets/icons/sync-problem.svg?react";
import styles from "./TabButton.module.scss";

export type TabButtonProps = {
  className?: string;
  state?: "default" | "selected";
  variant?: "default" | "small";
  label?: string;
  showAlertIcon?: boolean;
  showTag?: boolean;
  tagCount?: number;
  onSelect?: () => void;
};

export function TabButton({
  className,
  state = "default",
  variant = "default",
  label,
  showAlertIcon = false,
  showTag = false,
  tagCount = 0,
  onSelect,
}: TabButtonProps) {
  const handleClick = () => {
    if (onSelect) {
      onSelect();
    }
  };

  return (
    <button
      className={classNames(styles.root, className)}
      data-state={state}
      data-variant={variant}
      onClick={handleClick}
      type="button"
    >
      <div className={styles.content}>
        {label && <span className={styles.label}>{label}</span>}
        {showTag && (
          <div className={styles.tag}>
            <span className={styles.tagCount}>{tagCount}</span>
          </div>
        )}
        {showAlertIcon && (
          <AlertCircle className={styles.alertIcon} aria-label="Alerte" />
        )}
      </div>
    </button>
  );
}
